import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcTableRow } from '@one/react';

export type PocTableRowProps = ComponentPropsWithoutRef<typeof OwcTableRow>;

export const PocTableRow = forwardRef<ElementRef<typeof OwcTableRow>, PocTableRowProps>((props, ref) => (
    <OwcTableRow ref={ref} {...props} />
));

PocTableRow.displayName = 'PocTableRow';
